import styled, { css } from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledWrapper = styled.div`
	height: 100%;
	transition: opacity 0.3s ease;

	&.app-enter {
		opacity: 0;
	}

	&.app-enter-active,
	&.app-enter-done,
	&.app-exit {
		opacity: 1;
	}

	&.app-exit-active {
		opacity: 0;
	}
`;

const StyledContainer = styled.div`
	height: 100%;
	padding-top: 49px;
	background-color: #111111;
	transition: opacity 0.3s ease;

	&.loading-enter {
		opacity: 0;
	}

	&.loading-enter-active,
	&.loading-enter-done,
	&.loading-exit {
		opacity: 1;
	}

	&.loading-exit-active {
		opacity: 0;
	}
`;

const StyledRightContainer = styled.div`
	position: relative;
`;

const StyledItemPageContainer = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 15;
	background-color: #111111;
`;

const StyledLeftContainer = styled.div`
	display: flex;
	flex-direction: column;
	padding: 24px 20px 20px;
	background-color: rgba(255, 255, 255, 0.02);
	border-right: 1px solid rgba(255, 255, 255, 0.1);
	transition: width 0.3s ease;
	overflow: hidden;
	will-change: width;
`;

const StyledAppTitleContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	img {
		width: 30px;
		height: 30px;
		user-select: none;
		pointer-events: none;
	}

	div {
		overflow: hidden;
		white-space: nowrap;
		transition: opacity 0.3s ease;

		.title {
			font-weight: 500;
			font-size: 16px;
			color: #ffffff;
		}

		.text {
			font-weight: 400;
			font-size: 10px;
			color: #ffffff;
			opacity: 0.5;
		}
	}
`;

const StyledMenuContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

const StyledMenuItem = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	width: 100%;
	height: 40px;
	border-radius: 10px;
	transition:
		background-color 0.3s ease,
		padding 0.3s ease;
	cursor: pointer;
	overflow: hidden;
	will-change: padding;

	img {
		width: 14px;
		height: 14px;
		user-select: none;
		pointer-events: none;
		transition:
			filter 0.3s ease,
			opacity 0.3s ease;
	}

	${Text} {
		font-weight: 400;
		font-size: 14px;
		transition:
			color 0.3s ease,
			opacity 0.3s ease;
		white-space: nowrap;
	}

	&:hover {
		background-color: #ffffff;

		img {
			opacity: 1;
			filter: invert(100%);
		}

		${Text} {
			color: #000000;
		}
	}
`;

const StyledFilterButton = styled(StyledMenuItem)<{
	$color?: string;
	$active?: boolean;
}>`
	background-color: transparent;

	img {
		opacity: 0.5;
	}

	${Text} {
		color: rgba(255, 255, 255, 0.5);
	}

	${(props) =>
		props.$active &&
		css`
			background-color: ${props.$color};

			img {
				opacity: 1;
				filter: invert(0);
			}

			${Text} {
				color: #ffffff;
			}
		`}
`;

const StyledFavoriteButton = styled(StyledMenuItem)<{ $active?: boolean }>`
	background-color: transparent;

	img {
		opacity: 0.5;
	}

	${Text} {
		color: rgba(255, 255, 255, 0.5);
	}

	${(props) =>
		props.$active &&
		css`
			background-color: #ff1e00;

			img {
				opacity: 1;
				filter: invert(0);
			}

			${Text} {
				color: #ffffff;
			}
		`}
`;

const StyledAddButton = styled(StyledMenuItem)`
	background-color: #2d70da;

	${Text} {
		color: #ffffff;
	}
`;

const StyledExitButton = styled(StyledMenuItem)<{ $compact?: boolean }>`
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	transition:
		background-color 0.3s ease,
		border 0.3s ease;

	${Text} {
		color: #ffffff;
	}
`;

const StyledLayoutContainer = styled.div<{ $compact?: boolean }>`
	display: grid;
	grid-template-columns: 240px 1fr;
	height: 100%;
	border-top: 1px solid rgba(255, 255, 255, 0.1);
	transition: grid-template-columns 0.3s ease;
	will-change: grid-template-columns;

	${({ $compact }) =>
		$compact
			? css`
					grid-template-columns: 80px 1fr;

					${StyledLeftContainer} {
						width: 80px;
					}

					${StyledAppTitleContainer} {
						div {
							opacity: 0;
						}
					}

					${StyledMenuItem} {
						padding: 0 10px 0 13px;

						${Text} {
							opacity: 0;
						}
					}
			  `
			: css`
					grid-template-columns: 240px 1fr;

					${StyledLeftContainer} {
						width: 240px;
					}

					${StyledMenuItem} {
						padding: 0 10px;
					}
			  `}
`;

export {
	StyledAddButton,
	StyledAppTitleContainer,
	StyledContainer,
	StyledExitButton,
	StyledFavoriteButton,
	StyledFilterButton,
	StyledItemPageContainer,
	StyledLayoutContainer,
	StyledLeftContainer,
	StyledMenuContainer,
	StyledMenuItem,
	StyledRightContainer,
	StyledWrapper,
};
